module.exports = __webpack_public_path__ + "img/crm_sales5.01120752.png";